import { AssignmentLateOutlined } from "@material-ui/icons";
import { SafetyAlertsList } from "./SafetyAlertsList";

export default {
  icon: AssignmentLateOutlined,
  list: SafetyAlertsList,
};
